import type { CreateElement, VNode } from 'vue';
import notify from './notify';
import type { MessageType } from '@cognitoforms/element-ui/types/message';

type ButtonCallback = (ev: Event) => unknown;

export default (
	createElement: CreateElement,
	message: string | VNode,
	buttonText: string,
	buttonCallback: ButtonCallback,
	type: MessageType | 'custom' = 'info',
	duration: number = null,
	showClose: boolean = true,
	customIcon: string = null
) => {
	const formMessage = notify(
		createElement('span', { class: 'el-message__content w-full' }, [
			createElement('span', { domProps: { id: 'icon-slot' } }),
			createElement('span', { class: 'flex flex-col items-baseline' }, [
				message,
				createElement('button', {
					class: 'button--secondary block mt-3',
					on: {
						'click': buttonCallback
					}
				}, [buttonText])
			])
		]),
		type,
		duration,
		showClose,
		customIcon);
	return formMessage;
};
